const music = () => {
    document.querySelector("#bg").setAttribute("autoplay", "true")
};

export default music;
